<template>
  <v-card>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(submit)">

        <v-card-title>Изменить пароль</v-card-title>
        <v-card-text>
          <ValidationProvider name="detail" v-slot="{ errors }">
            <v-alert
              dense
              outlined
              type="error"
              v-if="errors[0]"
            >
              <div v-html="errors[0]" class="caption"></div>
            </v-alert>
          </ValidationProvider>
          <v-text-field
            style="display: none"
            autocomplete="old_password"
          ></v-text-field>
          <ValidationProvider name="old_password" rules="required|min:8|max:128" v-slot="{ errors }">
            <v-text-field
              id="old_password"
              v-model="old_password"
              :error-messages="errors"
              type="password"
              label="Текущий пароль"
              :messages="['Ваш текущий пароль от личного кабинета']"
              autocomplete="new-password"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="new_password1" rules="required|equal:@old_password|min:8|max:128"
                              v-slot="{ errors }">
            <v-text-field
              id="new_password1"
              v-model="new_password1"
              :error-messages="errors"
              type="password"
              label="Новый пароль"
              :messages="['Минимальная длина пароля 8 символов']"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="new_password2" rules="required|confirmed:new_password1|min:8|max:128"
                              v-slot="{ errors }">
            <v-text-field
              id="new_password2"
              v-model="new_password2"
              :error-messages="errors"
              type="password"
              label="Новый пароль повторно"
              :messages="['Новый пароль еще раз']"
            ></v-text-field>
          </ValidationProvider>
        </v-card-text>
        <v-card-actions>
          <v-btn
            dark
            right
            class="lighten-1"
            color="ma-2 indigo"
            type="submit"
            :loading="isLoading"
          >
            Сменить пароль
          </v-btn>
        </v-card-actions>
      </v-form>
    </ValidationObserver>
  </v-card>
</template>

<script>
  import {extend, localize, ValidationObserver, ValidationProvider} from "vee-validate";
  import {confirmed, max, required} from "vee-validate/dist/rules";
  import {mapGetters, mapMutations} from "vuex";

  export default {
    name: "PasswordChangeForm",
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    data() {
      return {
        old_password: '',
        new_password1: '',
        new_password2: '',
      }
    },
    computed: {
      ...mapGetters("context", [
        'isLoading',
        'messages',
      ]),
      ...mapGetters("auth", [
        'user',
      ]),
      ...mapMutations("context", [
        'CLEAR_MESSAGES',
      ])
    },
    methods: {
      async submit() {
        this.$store.commit('context/ENABLE_LOADING')
        await this.$refs.observer.validate()
          .then(success => {
            if (!success) {
              return;
            }

            const payload = {
              id: this.user.id,
              old_password: this.old_password,
              new_password1: this.new_password1,
              new_password2: this.new_password2,
            }
            this.$store.dispatch("auth/password_change", payload)
              .then(() => {
                if (this.messages) {
                  this.$refs.observer.setErrors(this.messages);
                } else if (!this.messages) {
                  this.$emit('showSnackbar', true)
                }
              })
              .catch(() => {
                this.$refs.observer.setErrors({
                  'detail': 'Неизвестная ошибка. Обратитесь в поддержку: <a href="mailto:abit@kuzstu.ru">abit@kuzstu.ru</a>',
                  'old_password': ' ',
                  'new_password1': ' ',
                  'new_password2': ' ',
                });
              })

            this.old_password = this.new_password1 = this.new_password2 = ''
            this.$nextTick(() => {
              this.$refs.observer.reset();
              this.CLEAR_MESSAGES;
            });
          })
        this.$store.commit('context/DISABLE_LOADING')
      }
    }
  }

  localize({
    ru: {
      names: {
        old_password: ' ',
        new_password1: ' ',
        new_password2: ' ',
      }
    }
  });

  extend('confirmed', {
    ...confirmed,
    message: 'Поле не совпадает с полем `Пароль`'
  });
  extend('equal', {
    params: ['target'],
    validate(value, {target}) {
      return value !== target;
    },
    message: 'Новый пароль сопадает с текущим паролем'
  });
  extend('required', {
    ...required
  });
  extend('max', {
    ...max
  });
</script>

<style scoped>

</style>
